export enum Browser {
  Firefox = "firefox",
  Chrome = "chrome"
}

export const checkIfBrowser = (browser: Browser) => {
  return navigator.userAgent.toLocaleLowerCase().indexOf(browser) > -1;
};
